



























import { Component, Prop, Vue } from 'vue-property-decorator';

import { IotCoreEndpoint } from '@/types/core-push';

@Component
export default class IotCoreEndpointView extends Vue {
  
  @Prop({ default: {},  type: Object}) iotCoreEndpoint!: IotCoreEndpoint;

  
}
